/* Progressive enhancements; purchase forms and prices remain Shopify-owned. */
(() => {
  const mobile = matchMedia('(max-width:749px)');
  function enhance() {
    document.body.classList.toggle('dv-brand-collection', Boolean(document.querySelector('.dv-collection-offer')));
    document.body.classList.toggle('dv-has-volume', Boolean(document.querySelector('.dv-volume-ladder, .dv-purchase-value')));
    const ladder = document.querySelector('.dv-volume-ladder, .dv-purchase-value');
    const purchase = document.querySelector('product-info product-form');
    if (ladder && purchase && purchase.nextElementSibling !== ladder) purchase.after(ladder);
    document.querySelectorAll('.footer-block--menu:not([data-dv-disclosure])').forEach(block => {
      const heading = block.querySelector('.footer-block__heading');
      if (!heading) return;
      block.dataset.dvDisclosure = 'true';
      const details = document.createElement('details');
      details.className = 'dv-footer-details';
      const summary = document.createElement('summary');
      summary.textContent = heading.textContent.trim();
      heading.remove();
      details.append(summary);
      while (block.firstChild) details.append(block.firstChild);
      block.append(details);
      details.open = !mobile.matches;
    });
  }
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.dv-footer-details').forEach(details => { details.open = !mobile.matches; });
  });
  enhance();
  document.addEventListener('shopify:section:load', enhance);
  // Bound checks accommodate asynchronously mounted Shopify controls without a subtree observer.
  let attempts = 0;
  const timer = setInterval(() => {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const activator = root?.querySelector('.activator');
    const label = root?.querySelector('.activator__label');
    if (activator && label && label.textContent === 'Chat') {
      label.textContent = 'Spjall';
      activator.setAttribute('aria-label', 'Spjall við Dýravini');
    }
    document.documentElement.classList.toggle('dv-preview-active', Boolean(document.querySelector('#PBarNextFrame,#preview-bar-iframe')));
    if (++attempts >= 20) clearInterval(timer);
  }, 1000);
})();
